import { uniqueId } from 'lodash';
import { useEffect, useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import OtherFile from './OtherFile';
import { useAuth } from '@/auth';
import { checkAllPermissions, PERMISSIONS } from '@/auth/permissions';


const OtherFileList = ({
    tramite_id,
    subtramite,
    categoria = null,
    onChange,
    value = [],
    canUpload = false,
    canView = false
}) => {
    const [files, setFiles] = useState(value);
    const [filesDelete, setFilesDelete] = useState([]);
    const [fieldsDelete, setFieldsDelete] = useState([]);
    const { user } = useAuth();
    const userPermissions = user?.permissions ?? [];
    const canManageTramites = checkAllPermissions(userPermissions, [PERMISSIONS.MANAGE_TRAMITES.name]);

    useEffect(() => {
        onChange && onChange({
            files,
            fieldsDelete,
            filesDelete,
        });
    }, [files]);

    const addFile = () => {
        const file = {
            "key": uniqueId('otherfile'),
            "tramite_id": tramite_id,
            "subtramite": subtramite,
            "name": "",
            "path": null,
            "categoria": categoria,
            "comprador_read": false,
            "comprador_write": false,
            "vendedor_read": false,
            "vendedor_write": false,
            "file": null
        }
        setFiles([...files, file]);
    }
    const getCallbackDelete = (index) => {
        return () => {
            if (files[index]?.id) setFieldsDelete([...fieldsDelete, files[index]]);
            const value = [...files];
            value.splice(index, 1);
            setFiles(value);
        }
    }
    const getCallbackChange = (index) => {
        return (fileData) => {
            const newArray = [...files];
            newArray[index].name = fileData.name;
            newArray[index].comprador_read = fileData.permissions.comprador_read;
            newArray[index].comprador_write = fileData.permissions.comprador_write;
            newArray[index].vendedor_read = fileData.permissions.vendedor_read;
            newArray[index].vendedor_write = fileData.permissions.vendedor_write;
            newArray[index].file = fileData.file;
            if (fileData.fileDelete) {
                setFilesDelete([...filesDelete, fileData.fileDelete]);
            }
            setFiles(newArray);
        }
    }

    return (
        <>
            {(canManageTramites) && (
                <Button
                    variant="ghost"
                    size="sm"
                    onClick={addFile}
                    className="mb-4 rounded-full h-8 w-8 p-0"
                >
                    <Plus className="h-4 w-4 text-blue-500" />
                </Button>
            )}

            {files.map((f, i) => <OtherFile
                key={f.key || `otherfileid-${f.id}`}
                file={f}
                onDelete={getCallbackDelete(i)}
                onChange={getCallbackChange(i)}
                canUpload={canUpload}
                canView={canView}
            />)}
        </>
    );
}

export default OtherFileList;